$(document).ready(function () {
  // -----------------  search

  $("header-drawer #menu-drawer.menu-drawer .menu-drawer-tab-toggle").click(
    function (e) {
      e.preventDefault();
      var target = $(this).data("tab-target");
      $(this).siblings(".menu-drawer-tab-toggle").removeClass("active");
      $(this).addClass("active");
      $(
        '#menu-drawer.menu-drawer .menu-drawer-tabs-wrap .menu-drawer-tab[data-tab="' +
          target +
          '"]'
      )
        .siblings(".menu-drawer-tab")
        .removeClass("active");
      $(
        '#menu-drawer.menu-drawer .menu-drawer-tabs-wrap .menu-drawer-tab[data-tab="' +
          target +
          '"]'
      ).addClass("active");
    }
  );

  function open_search() {
    $(
      ".search-modal .search_model-container,.search-modal .modal-overlay"
    ).fadeIn();
    $(".header__search .search-modal").addClass("open-search-model");
    $("#Search-In-Modal").trigger("focus");
    $("body").addClass("overflow-hidden");
  }

  function close_search() {
    $(
      ".search-modal .search_model-container,.search-modal .modal-overlay"
    ).fadeOut();
    $(".header__search .search-modal").removeClass("open-search-model");
    $("body").removeClass("overflow-hidden");
  }

  $("body").click(function () {
    close_search();
  });
  $(".header__search").click(function (e) {
    e.stopPropagation();
  });

  $(".header__search .header__icon--search").click(function () {
    open_search();
  });

  $("#search-model-input").focus(function () {
    setTimeout(open_search, 200);
  });

  $(
    ".search-modal .modal-overlay, .search-modal .search-modal__close-button"
  ).click(function () {
    close_search();
  });

  $("#search-model-input").keyup(function () {
    var form = $(this).parents("form").serialize();
    fetch(`/search?${form}&section_id=header`)
      .then((responseText) => responseText.text())
      .then((responseText) => {
        console.log(responseText);
        const html = new DOMParser().parseFromString(responseText, "text/html");
        $(".search-modal .search_model-container").html(
          $(html).find(".search-modal .search_model-container").html()
        );
      });
  });

  $(".drawer_mobile_close").click(function () {
    $(".header__icon--menu").trigger("click");
  });
  $(
    ".header_poppup_click .search__input, .header_poppup_click .search__button"
  ).click(function () {
    $(".header_modal_search_main").addClass("active");
    $("html").css("overflow", "hidden");
    $("body").addClass("menu_modle");
    $(".header_poppup_click").addClass("active");
  });

  $(
    ".search-modal__close-button, .modal-overlay, .header_poppup_click .modal__toggle-close, body"
  ).click(function () {
    $(".header_modal_search_main").removeClass("active");
    $("html").css("overflow", "");
    $("body").removeClass("menu_modle");
    $(".header_poppup_click").removeClass("active");
  });
});

$(document).ready(function () {
  $(".grid__item")
    .find(".card_product_variant li")
    .off("click")
    .on("click", function () {
      $(this).parents(".card_product_variant").find("li").removeClass("active");
      $(this).addClass("active");
      var variant = $(this).attr("data-variant");
      var image = $(this).attr("data-image");
      $(this)
        .parents(".grid__item")
        .find(".card__media img")
        .attr("src", image);
      $(this)
        .parents(".grid__item")
        .find("product-form .product-variant-id")
        .attr("value", variant);
    });
});
